import { FunctionComponent, useEffect, useRef, useState } from 'react';


import styles from './section5.module.css';
const Section5: FunctionComponent = () => {
	const sectionRef = useRef<HTMLDivElement | null>(null);
	const [, setVisibleCards] = useState<number[]>([]);
	const [animate, setAnimate] = useState(false);
	const intervalRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		const element = sectionRef.current;
		if (!element) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				console.log("Component visibility:", entry.isIntersecting);

				if (entry.isIntersecting) {
					setAnimate(true);
					if (intervalRef.current) clearInterval(intervalRef.current);

					let cardIndex = 0;
					intervalRef.current = setInterval(() => {
						setVisibleCards((prev) => [...prev, cardIndex]);
						cardIndex++;
						if (cardIndex >= 4) clearInterval(intervalRef.current!);
					}, 300); // Delay between cards
				} else {
					if (intervalRef.current) {
						clearInterval(intervalRef.current);
						intervalRef.current = null;
					}
					setVisibleCards([]); // Reset cards when out of view
				}
			},
			{ threshold: 0.3, rootMargin: "0px" }
		);

		observer.observe(element);

		return () => {
			observer.disconnect();
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
				intervalRef.current = null;
			}
		};
	}, []);


	return (
		<div ref={sectionRef} className={`${styles.withYouAtAllTimesParent} ${animate ? styles.animate : ''}`} style={{ marginTop: "180px" }}>
			<div className={styles.withYouAt}>With You At All Times!</div>
			<div className={styles.groupWrapper}>
				<div className={styles.vectorParent}>
					<img className={styles.groupChild} alt="" src="./assets/Vector 5.svg" />
					<div className={styles.day171}>
						<div className={styles.descParent}>
							<div className={styles.desc}>
								<div className={`${styles.desc1} ${animate ? styles.animate : ''}`}>
									<div className={styles.mutilingualCallingVoiceBotParent}>
										<div className={styles.mutilingualCallingVoiceContainer}>
											<span className={styles.mutilingualCallingVoiceContainer1}>
												<p className={styles.mutilingualCallingVoice} style={{ fontFamily: "Geist,sans-serif" }}>Multi Lingual Calling , SMS, WAs</p>

											</span>
										</div>
										<div className={styles.gradient} />
									</div>
									<div className={styles.automateMissedRepaymentsContainer}>
										<p className={styles.mutilingualCallingVoice} style={{ fontFamily: "Geist,sans-serif" }}>Automate Missed Repayments, Bucket High-Risk Customers, Route to Voice for Recovery.</p>

									</div>
								</div>
							</div>
							<div className={styles.earlyDelinquentT1Container}>
								<p className={styles.mutilingualCallingVoice}>{`Early Delinquent`}</p>
								<p className={styles.mutilingualCallingVoice}>{`T+1 > T+5`}</p>
							</div>
						</div>
						<div className={styles.pinContainer} style={{ marginTop: "40px", marginLeft: "-40px" }}>
							<img className={styles.pinIcon} alt="" src="./assets/pin.svg" />
							<img className={styles.vectorIcon} alt="" src="./assets/pinbase.svg" />
						</div>

					</div>
					<div className={styles.day168}>
						<div className={styles.pinContainer}>
							<img className={styles.pinIcon} alt="" src="./assets/pin.svg" />
							<img className={styles.vectorIcon} alt="" src="./assets/pinbase.svg" />
						</div>
						<div className={styles.descParent}>
							<div className={styles.preDelinquentT4Container}>
								<p className={styles.mutilingualCallingVoice} style={{ fontFamily: "Geist,sans-serif" }}>Pre Delinquent</p>
								<p className={styles.mutilingualCallingVoice}>{`T-4 > T`}</p>
							</div>
							<div className={styles.desc2}>
								<div className={`${styles.desc1} ${animate ? styles.animate : ''}`}>
									<div className={styles.mutilingualCallingVoiceBotParent} style={{marginLeft:"11px"}}>
										<div className={styles.digitalCommunicationsVoice} style={{ fontFamily: "Geist,sans-serif" }}>Voice Bot IVR, SMS, WA</div>
										<div className={styles.gradient} />
									</div>
									<div className={styles.aiPoweredDigital} style={{ fontFamily: "Geist,sans-serif" }}>AI-Powered Digital Stack to Significantly Reduce Bounce Rate and Improve User Engagement and Retention.

</div>
								</div>
							</div>
						</div>
					</div>
					<div className={styles.day170}>
						<div className={styles.pinContainer}>
							<img className={styles.pinIcon} alt="" src="./assets/pin.svg" />
							<img className={styles.vectorIcon} alt="" src="./assets/pinbase.svg" />
						</div>
						<div className={styles.descParent}>
							<div className={styles.earlyDelinquentT1Container1}>
								<p className={styles.mutilingualCallingVoice}>{` `}</p>
								<p className={styles.mutilingualCallingVoice}>{`Bucket 1 T+30`}</p>
							</div>
							<div className={styles.desc2}>
								<div className={`${styles.desc1} ${animate ? styles.animate : ''}`}>
									<div className={styles.mutilingualCallingVoiceBotParent}>
										<div className={styles.mutilingualCallingVoiceContainer}>
											<span className={styles.mutilingualCallingVoiceContainer1}>
												<p className={styles.mutilingualCallingVoice} style={{ fontFamily: "Geist,sans-serif" }}>Voice Bot

													Multi Lingual Calling</p>
												{/* <p className={styles.mutilingualCallingVoice}> IVR, SMS, WA</p> */}
											</span>
										</div>
										<div className={styles.gradient} />
									</div>
									<div className={styles.automateMissedRepaymentsContainer}>
										<p className={styles.mutilingualCallingVoice} style={{ fontFamily: "Geist,sans-serif" }}>Automated Workflows Ending with Voice Channels for Maximum Issue Resolution and Customer Satisfaction.</p>
										{/* <p className={styles.mutilingualCallingVoice}> Bucket High Risk and assign to</p>
										<p className={styles.mutilingualCallingVoice}> Voice Channels</p> */}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className={styles.day172}>
						<div className={styles.descParent}>
							<div className={styles.desc}>
								<div className={`${styles.desc1} ${animate ? styles.animate : ''}`}>
									<div className={styles.mutilingualCallingVoiceBotParent}>
										<div className={styles.mutilingualCallingVoiceContainer}>
											<span className={styles.mutilingualCallingVoiceContainer1}>
												<p className={styles.mutilingualCallingVoice} style={{ fontFamily: "Geist,sans-serif" }}>Field Intervention Voice Bot Multi Lingual Calling.</p>

											</span>
										</div>
										<div className={styles.gradient} />
									</div>
									<div className={styles.automateMissedRepaymentsContainer}>
										{/* <p className={styles.mutilingualCallingVoice}>Automate Missed Repayments.</p>
										<p className={styles.mutilingualCallingVoice}> Bucket High Risk and assign to</p> */}
										<p className={styles.mutilingualCallingVoice} style={{ fontFamily: "Geist,sans-serif" }}>High Intensification on Low Response & High Risk with Field-End Workflows.</p>
									</div>
								</div>
							</div>
							<div className={styles.earlyDelinquentT1Container}>
								<p className={styles.mutilingualCallingVoice}>{`Bucket 2`}</p>
								<p className={styles.mutilingualCallingVoice}>{`T+30 > T+60`}</p>
							</div>
						</div>
						<div className={styles.pinContainer} style={{ marginLeft: "-30px" }}>
							<img className={styles.pinIcon} alt="" src="./assets/pin.svg" />
							<img className={styles.vectorIcon} alt="" src="./assets/pinbase.svg" />
						</div>
					</div>
					<div className={styles.day173}>
						<div className={styles.descParent}>
							<div className={styles.desc}>
								<div className={`${styles.desc1} ${animate ? styles.animate : ''}`}>
									<div className={styles.mutilingualCallingVoiceBotParent}>
										<div className={styles.mutilingualCallingVoiceContainer}>
											<span className={styles.mutilingualCallingVoiceContainer1}>
												<p className={styles.mutilingualCallingVoice} style={{ fontFamily: "Geist,sans-serif" }}>Skip Tracing Field Intervention Legal</p>
												{/* <p className={styles.mutilingualCallingVoice}> IVR, SMS, WA</p> */}
											</span>
										</div>
										<div className={styles.gradient} />
									</div>
									<div className={styles.automateMissedRepaymentsContainer}>
										<p className={styles.mutilingualCallingVoice} style={{ fontFamily: "Geist,sans-serif" }}>Accurate Dispositions Achieved with Comprehensive and Tailored Action Plans to Resolve NPA Effectively.</p>
										{/* '<p className={styles.mutilingualCallingVoice}> Bucket High Risk and assign to</p> */}
										{/* <p className={styles.mutilingualCallingVoice}> Voice Channels</p> */}
									</div>
								</div>
							</div>
							<div className={styles.earlyDelinquentT1Container}>
								<p className={styles.mutilingualCallingVoice}>{`(T+90) &NPA`}</p>
								{/* <p className={styles.mutilingualCallingVoice}>{`&NPA`}</p> */}
							</div>
						</div>
						<img className={styles.pinIcon} style={{ marginTop: "50px" }} alt="" src="./assets/pin.svg" />
						<img className={styles.vectorIcon} alt="" src="./assets/pinbase.svg" />
					</div>
					<div className={styles.day174}>
						<div className={styles.pinContainer}>
							<img className={styles.pinIcon} alt="" src="./assets/pin.svg" />
							<img className={styles.vectorIcon} alt="" src="./assets/pinbase.svg" />
						</div>
						<div className={styles.descParent}>
							<div className={styles.earlyDelinquentT1Container1}>
								<p className={styles.mutilingualCallingVoice}>{`Bucket 3 T+60>T+90 `}</p>
								{/* <p className={styles.mutilingualCallingVoice}>{`T+1 > T+5`}</p> */}
							</div>
							<div className={styles.desc2}>
								<div className={`${styles.desc1} ${animate ? styles.animate : ''}`}>
									<div className={styles.mutilingualCallingVoiceBotParent}>
										<div className={styles.mutilingualCallingVoiceContainer}>
											<span className={styles.mutilingualCallingVoiceContainer1}>
												<p className={styles.mutilingualCallingVoice} style={{ fontFamily: "Geist,sans-serif" }}>Skip Tracing

													Field Intervention

													Legal</p>
												{/* <p className={styles.mutilingualCallingVoice}> IVR, SMS, WA</p> */}
											</span>
										</div>
										<div className={styles.gradient} />
									</div>
									<div className={styles.automateMissedRepaymentsContainer}>
										<p className={styles.mutilingualCallingVoice} style={{ fontFamily: "Geist,sans-serif" }}>Workflows prioritising Field Intervention for low contact and legal for Intent. Combination best suited for max resolution</p>

									</div>
								</div>
							</div>
						</div>
					</div>
					<img className={styles.image206Icon} alt="" src="./assets/crdhs.png" />
					<img className={styles.image208Icon} alt="" src="./assets/crdhs.png" />
				</div>
			</div>
		</div>);
};

export default Section5;
// import { FunctionComponent } from 'react';
// import { motion } from 'framer-motion';
// import styles from './section5.module.css';

// const fadeInUp = {
//   hidden: { opacity: 0, y: 20 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
// };

// const fadeIn = {
//   hidden: { opacity: 0 },
//   visible: { opacity: 1, transition: { duration: 1 } }
// };

// const Section5: FunctionComponent = () => {
//   return (
//     <motion.div 
//       className={styles.withYouAtAllTimesParent} 
//       initial="hidden" 
//       animate="visible" 
//       variants={fadeIn}
//     >
//       <motion.div className={styles.withYouAt} variants={fadeInUp}>
//         With You At All Times!
//       </motion.div>
//       <div className={styles.groupWrapper}>
//         <motion.div className={styles.vectorParent} variants={fadeInUp}>
//           <motion.img 
//             className={styles.groupChild} 
//             alt="" 
//             src="./assets/Vector5.png" 
//             initial={{ opacity: 0, scale: 0.9 }} 
//             animate={{ opacity: 1, scale: 1 }} 
//             transition={{ duration: 0.8 }}
//           />
//           <motion.div className={styles.day171} variants={fadeInUp}>
//             <div className={styles.descParent}>
//               <div className={styles.desc}>
//                 <div className={styles.desc1}>
//                   <motion.div className={styles.mutilingualCallingVoiceBotParent} variants={fadeInUp}>
//                     <div className={styles.mutilingualCallingVoiceContainer}>
//                       <span className={styles.mutilingualCallingVoiceContainer1}>
//                         <p className={styles.mutilingualCallingVoice}>Mutilingual Calling Voice Bot</p>
//                         <p className={styles.mutilingualCallingVoice}>IVR, SMS, WA</p>
//                       </span>
//                     </div>
//                     <div className={styles.gradient} />
//                   </motion.div>
//                   <motion.div className={styles.automateMissedRepaymentsContainer} variants={fadeInUp}>
//                     <p className={styles.mutilingualCallingVoice}>Automate Missed Repayments.</p>
//                     <p className={styles.mutilingualCallingVoice}>Bucket High Risk and assign to Voice Channels</p>
//                   </motion.div>
//                 </div>
//               </div>
//               <motion.div className={styles.earlyDelinquentT1Container} variants={fadeInUp}>
//                 <p className={styles.mutilingualCallingVoice}>Early Delinquent</p>
//                 <p className={styles.mutilingualCallingVoice}>T+1  T+5</p>
//               </motion.div>
//             </div>
//             <motion.div className={styles.pinContainer} variants={fadeInUp}>
//               <motion.img className={styles.pinIcon} alt="" src="./assets/pin.svg" initial={{ rotate: 180 }} animate={{ rotate: 0 }} transition={{ duration: 0.6 }}/>
//               <motion.img className={styles.vectorIcon} alt="" src="./assets/pinbase.svg" initial={{ scale: 0.8 }} animate={{ scale: 1 }} transition={{ duration: 0.8 }}/>
//             </motion.div>
//           </motion.div>
//         </motion.div>
//       </div>
//     </motion.div>
//   );
// };

// export default Section5;
